import React from 'react'
import useEvents from 'pages/Cms/event-list/use-events'
import BackButton from 'redesign/components/atoms/Buttons/BackButton'
import CloseButton from 'redesign/components/atoms/Buttons/CloseButton/CloseButton'
import HeaderLabel from 'redesign/components/molecules/HeaderLabel'
import { DrawerHeaderWrapper } from 'redesign/components/molecules/drawer-header-wrapper'
import { ListWrapper } from 'redesign/components/organisms/side-menu-task-list-content/styles'
import { EVENT_TIMELINE_FILTERS } from 'types/cms'
import Header from '../../../organisms/Header'
import { SIDE_MENU_OPTIONS, SIDE_MENU_TRANSLATIONS } from '../../SideMenu/constants'
import type { MenuPageProps } from '../../SideMenu/types'
import EventsList from '../../events-list'
import EventDetail from '../event-detail'

const EventsPage: React.FC<MenuPageProps> = ({ onClose, t, setPage, isDrawer, parentPage }) => {
  const { groupedEvents, loading, hasMoreElements, loadMore, selectedEvent, setSelectedEvent } = useEvents({
    eventTimelineFilter: EVENT_TIMELINE_FILTERS.UPCOMING,
  })

  if (selectedEvent) {
    return (
      <EventDetail
        selectedEvent={selectedEvent}
        onGoBack={() => setSelectedEvent(undefined)}
        onClose={() => {
          setSelectedEvent(undefined)
          onClose()
        }}
        parentPage={parentPage}
        titleKey="absencePlanner.taskbar.eventDetails.title"
      />
    )
  }

  return (
    <DrawerHeaderWrapper
      header={
        <Header
          startContent={isDrawer && <BackButton onGoBack={() => setPage(SIDE_MENU_OPTIONS.mainMenu)} />}
          middleContent={<HeaderLabel mainText={t(SIDE_MENU_TRANSLATIONS[SIDE_MENU_OPTIONS.events])} />}
          endContent={isDrawer && <CloseButton onClick={onClose} />}
        />
      }
      providerName="events-list"
    >
      <ListWrapper>
        <EventsList
          groupedEvents={groupedEvents}
          hasMoreElements={hasMoreElements}
          loadMore={loadMore}
          isLoading={loading}
          onClickCard={setSelectedEvent}
        />
      </ListWrapper>
    </DrawerHeaderWrapper>
  )
}

export default EventsPage
